import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiCall } from '../utils/api.js'

export const useLocalBackendStore = defineStore('localBackend', () => {
  const isConnected = ref(false)
  const isChecking = ref(false)
  const configurationError = ref(null)
  const missingPaths = ref([])
  const warnings = ref([])

  async function checkConnection() {
    isChecking.value = true
    configurationError.value = null
    missingPaths.value = []
    warnings.value = []
    
    try {
      // Verifica connessione e valida configurazione
      const validation = await apiCall('/api/config/config/validate', {
        method: 'GET',
        backend: 'local',
        includeAuth: false
      })
      
      // Se la configurazione non è valida, disabilita le funzionalità
      if (!validation.isValid) {
        configurationError.value = 'Configuration paths are invalid or missing'
        missingPaths.value = validation.missingPaths || []
        isConnected.value = false
        return false
      }
      
      // Salva eventuali warnings (template o archive path mancanti)
      if (validation.warnings && validation.warnings.length > 0) {
        warnings.value = validation.warnings
      }
      
      isConnected.value = true
      return true
    } catch (error) {
      isConnected.value = false
      configurationError.value = 'LocalBackend not available'
      return false
    } finally {
      isChecking.value = false
    }
  }

  return {
    isConnected,
    isChecking,
    configurationError,
    missingPaths,
    warnings,
    checkConnection
  }
})
